 
// Disabling prop-types for column/data which are objects built by react-table library
import { useState } from 'react';
import styled from '@emotion/styled/macro';
import { css } from '@emotion/react';
import { Cell } from './Base';
import Filter from './Filter';
import { Icon } from '../../ui_elements/icons';
import { colors, fonts } from '../../styles';
import customIcons from '../../styles/icons';
import { H6 } from '../../base';

const HeaderIcon = styled(Icon)`
  color: ${colors.grey.altLight};
  &:hover {
    cursor: pointer;
    color: ${colors.grey.primaryLight};
  }
`;

const HeaderTitle = styled(H6)`
  margin: 0;
  width: 100%;
  min-height: 30px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  > input,
  > div {
    box-shadow: 0 1px 0 0 ${colors.blue.secondaryDark};
  }
`;

const SortedColumn = css`
  background: ${colors.blue.secondaryLight};
  color: ${colors.blue.primary};
  ${HeaderTitle}::before {
    ${fonts.icons};
    content: '${customIcons['angle-down']}';
  }
`;

const HeaderColumn = styled(Cell)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 30px;
  min-width: 0;
  max-width: none;
  position: relative;
  padding-left: ${(props) => (props.sorted ? '25px' : '15px')};
  padding-right: ${(props) => (props.sorted ? '5px' : '15px')};
  ${HeaderTitle}::before {
    color: ${colors.blue.primaryDark};
    position: absolute;
    top: 12px;
    left: 4px;
    font-size: 18px;
  }
  ${HeaderIcon} {
    margin-right: ${(props) => (props.sorted ? '10px' : '0')};
    margin-left: 10px;
  }
  ${(props) =>
    props.sortedIndex >= 0 &&
    (props.sortedDesc
      ? css`
          ${SortedColumn}
          ${HeaderTitle}::before {
            content: '${customIcons['angle-up']}';
          }
        `
      : css`
          ${SortedColumn}
          ${HeaderTitle}::before {
            content: '${customIcons['angle-down']}';
          }
        `)};
`;

export const DeleteHeaderCell = () => (
  <HeaderColumn>
    <HeaderTitle>Delete</HeaderTitle>
  </HeaderColumn>
);

export const HeaderCell = ({ column, filters }) => {
  const [showFilter, setShowFilter] = useState(filters.some((filter) => filter.id === column.id));

  let iconType;
  if (column.filterOptions) {
    iconType = column.filterOptions.type === 'search' ? 'search' : 'filter';
    iconType = showFilter ? 'x' : iconType;
  }

  const renderFilter = () => {
    if (!showFilter || !column.filterOptions) return column.render('Header');
    return <Filter column={column} />;
  };

  return (
    <HeaderColumn
      {...column.getHeaderProps()}
      sorted={column.sorted}
      sortedDesc={column.isSortedDesc}
      sortedIndex={column.sortedIndex}
    >
      <HeaderTitle {...column.getSortByToggleProps()}>{renderFilter()}</HeaderTitle>
      {column.filter ? (
        <HeaderIcon type={iconType} onClick={() => setShowFilter(!showFilter)} />
      ) : null}
    </HeaderColumn>
  );
};
